import { render } from "./form-head.vue?vue&type=template&id=0c8b67cc"
import script from "./form-head.vue?vue&type=script&lang=js"
export * from "./form-head.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__